"use client";

import { c as _c } from "react/compiler-runtime";
import { RegularLink, type RegularLinkProps } from "@/components/Link/RegularLink.component";
import { SnowplowLink } from "@/vendors/Snowplow/components/SnowplowLink.component";
import type { SnowplowClickTrackingModel } from "@/vendors/Snowplow/models/snowplow-click-tracking.model.types";
import { type WebviewArticle, WebviewLink } from "@/vendors/webview/components/WebviewLink.component";
import { useWebview } from "@/vendors/webview/context/webview-client.context";
type TrackingModel = Omit<SnowplowClickTrackingModel, "classes" | "consent" | "user" | "jpmuid" | "url">;
export type LinkProps = RegularLinkProps & {
  readonly webviewArticle?: WebviewArticle;
  readonly trackingModel?: TrackingModel;
};
export function Link(t0) {
  const $ = _c(12);
  let props;
  let trackingModel;
  let webviewArticle;
  if ($[0] !== t0) {
    ({
      webviewArticle,
      trackingModel,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = trackingModel;
    $[3] = webviewArticle;
  } else {
    props = $[1];
    trackingModel = $[2];
    webviewArticle = $[3];
  }
  const {
    isWebview
  } = useWebview();
  if (isWebview) {
    let t1;
    if ($[4] !== props || $[5] !== webviewArticle) {
      t1 = <WebviewLink {...props} webviewArticle={webviewArticle} />;
      $[4] = props;
      $[5] = webviewArticle;
      $[6] = t1;
    } else {
      t1 = $[6];
    }
    return t1;
  }
  if (trackingModel) {
    let t1;
    if ($[7] !== props || $[8] !== trackingModel) {
      t1 = <SnowplowLink {...props} trackingModel={trackingModel} />;
      $[7] = props;
      $[8] = trackingModel;
      $[9] = t1;
    } else {
      t1 = $[9];
    }
    return t1;
  }
  let t1;
  if ($[10] !== props) {
    t1 = <RegularLink {...props} />;
    $[10] = props;
    $[11] = t1;
  } else {
    t1 = $[11];
  }
  return t1;
}